/* eslint-disable no-useless-constructor */
import feathersClient, { makeServicePlugin, BaseModel } from '../../api'

class Agb extends BaseModel {
  constructor (data, options) {
    super(data, options)
  }

  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Agb'
  // Define default properties here
  static instanceDefaults () {
    return {
      doc: {
        template: '',
        attachmentIds: [],
        modules: []
      },
      products: [],
      status: 'DRAFT'
    }
  }

  static setupInstance (data, { models }) {
    if (data.file) {
      data.file = new models.api.File(data.file)
    }
    return data
  }
}
const servicePath = 'agbs'
const servicePlugin = makeServicePlugin({
  Model: Agb,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
